import React from 'react';
import { Card, Skeleton } from '@perch-labs/shrike';

export const LoadingContent = () => (
  <Card.Content>
    <Skeleton
      data-testid="loading-content"
      height="72px"
      margin={{ bottom: '32px', top: '8px' }}
      backgroundColor="secondary"
      width="100%"
      withShimmer
    />
    <Skeleton
      height="48px"
      backgroundColor="tertiary"
      width="100%"
      withShimmer
    />
  </Card.Content>
);
